import { render, staticRenderFns } from "./UsersWorkForm.vue?vue&type=template&id=bc5a9814&scoped=true"
import script from "./UsersWorkForm.vue?vue&type=script&lang=js"
export * from "./UsersWorkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5a9814",
  null
  
)

export default component.exports